import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from '../../store/actions/todoActions';

import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";
import CheckBox from "../../components/Common/CheckBox";
import ModalBox from "../../components/Common/ModalBox";
import { useSessionTimer } from "../../components/Common/utils";
import ArticleSlider from "./ArticleSlider";
import FlashSaleSlider from "./FlashSaleSlider";
import ImageSlider from "./ImageSlider";
import MobileAccessBanner from "./MobileAccessBanner";
import PopularnCategoryItems from "./PopularnCategory";
import TabCategorySlider from "./TabCategory";
import ShorcutPage from "./ShorcutPage";

function Homepages() {
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const [sliderData, setSliderData] = useState([]);
  const [trendingData, setTrendingData] = useState([]);
  const [flashSaleData, setFlashSaleData] = useState([]);
  const [logicFlashsale, setLogicFlashsale] = useState({});
  const [productData, setProductData] = useState([]);
  const [listProduct, setListProduct] = useState([]);
  const [articleData, setArticleData] = useState([]);

  const [sliderLoading, setSliderLoading] = useState(true);
  const [trendingLoading, setTrendingLoading] = useState(true);
  const [flashSaleLoading, setFlashSaleLoading] = useState(true);
  const [productLoading, setProductLoading] = useState(true);
  const [articleLoading, setArticleLoading] = useState(true);

  const [tabcategroy, setTabCategory] = useState('Game');

  const [isModalAds, setisModalAds] = useState(false);
  const [sessionData, startSession] = useSessionTimer('adsHomepages');

  const dispatch = useDispatch();

  useEffect(() => {
    fetchDataSlider();
    fetchDataPopuler();
    fetchDataFlashSale();
    fetchDataProduct();
    fetchDataArticle();
    dispatch(isIdTarget(undefined));
    parseWebSetting?.popup_status === "1" && !sessionData && setisModalAds(true)
  }, [dispatch]);

  const fetchDataSlider = async () => {
    setSliderLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/slider",
        // parameter: 'your-parameters',
        // apiKey: 'your-api-key',
        // token: 'your-token',
        method: "GET",
        XGORDON: "SLIDER"
      });
      setSliderLoading(false);
      if (response?.statusCode === 200) {
        setSliderData(response.result.data);
      } else {
        setSliderData([]);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataPopuler = async () => {
    setTrendingLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/trending",
        method: "GET",
        XGORDON: "TRENDING"
      });
      setTrendingLoading(false);
      if (response?.statusCode === 200) {
        setTrendingData(response.result.data);
      } else {
        setTrendingData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDataFlashSale = async () => {
    setFlashSaleLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/flashsale",
        method: "GET",
        XGORDON: "FLASHSALE"
      });
      setFlashSaleLoading(false);
      if (response?.statusCode === 200) {
        const newData = {
          id: "xxxxxxxxxxxx",
        };
        const updatedData = [...response.result.data || []];
        // updatedData.unshift(newData);
        setFlashSaleData(updatedData);
        setLogicFlashsale(response.result.flash_sale);
      } else {
        setFlashSaleData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDataProduct = async () => {
    setProductLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/kategori",
        method: "GET",
        XGORDON: "KATEGORI"
      });
      setProductLoading(false);
      if (response?.statusCode === 200) {
        setProductData(response?.result.data);
        setTabCategory(response?.result.data[0]?.jenis || "")

        const allCategory = response?.result.data.reduce((accumulator, current) => {
          return [...accumulator, ...current.kategori];
        }, []);
        const listProduct = allCategory.map((item) => {
          return {
            ...item,
            jenis: response?.result.data.find((jenis) =>
              jenis.kategori.some((kategori) => kategori.nama === item.nama)
            ).jenis,
          };
        });
        const slugArray = listProduct.map(item => item.slug);
        localStorage.setItem('isProduct', JSON.stringify(slugArray));

        setListProduct(listProduct);

      } else {
        setProductData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchDataArticle = async () => {
    setArticleLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/jenisBlog?trending",
        method: "GET",
        XGORDON: "JENISBLOG"
      });
      setArticleLoading(false);
      if (response?.statusCode === 200) {
        setArticleData(response.result.data);
      } else {
        setArticleData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="flex flex-col gap-3 flex-1">
      {/* <ShorcutPage/> */}
      <MobileAccessBanner />

      <ImageSlider
        sliderData={sliderData}
        sliderLoading={sliderLoading}
      />

      <PopularnCategoryItems
        trendingData={trendingData}
        trendingLoading={trendingLoading}
      />

      <FlashSaleSlider
        flashSaleData={flashSaleData}
        logicFlashsale={logicFlashsale}
        flashSaleLoading={flashSaleLoading} />

      <TabCategorySlider
        listProduct={listProduct}
        productData={productData}
        productLoading={productLoading}
        tabcategroy={tabcategroy}
        setTabCategory={setTabCategory}
      />

      <ArticleSlider
        articleData={articleData}
        articleLoading={articleLoading} />

      <ModalBox active={isModalAds} onClose={() => {
        setisModalAds(false)
      }}>
        <LazyLoadImage
          src={parseWebSetting?.popup_image}
          alt={"ads"}
          height={"100%"}
          className="rounded-lg w-full h-full object-cover group-hover:blur-xl"
          effect="blur"
        />
        <CheckBox
        label="Jangan Tampilkan Lagi"
        onChange={(event) => {
          if (event) {
            setisModalAds(false)
            startSession(true);
          } 
        }}
      />
      </ModalBox>
    </div>
  );
}

export default Homepages;
